var map = {
	"./arrow-diagonal.svg": 1164,
	"./close.svg": 9879,
	"./down.svg": 8897,
	"./filter.svg": 5819,
	"./minus.svg": 151,
	"./play.svg": 8143,
	"./plus.svg": 6681,
	"./search.svg": 6101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3216;